import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import EdButton from "@frameworks/web/components//generic/edbutton/edButton";
import InputField from "@frameworks/web/components/generic/inputField";
import { emailRegex, pan, phoneNo } from "@frameworks/web/utils/regex";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { useNavigate } from "react-router-dom";
import india from "../../../../assets/images/generic/India.svg";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import { LoginRequestMode, } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { useSelector } from "react-redux";
import { ChooseAccountForLogin } from "../ClientUser/chooseAccntForLogin";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import { loginHelp } from "../LogintextConfig";
import { forgotLoginIdState } from "../constant";
import PasswordResetMsg from "./PasswordResetMsg";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
const inputfield = {
    mobile: "",
    pan: "",
    email: "",
};
const number = () => (React.createElement(React.Fragment, null,
    React.createElement("img", { src: india }),
    " +91"));
const ForgotLoginId = (props) => {
    const device = DeviceContext();
    const redirectUrlFromQueryParams = getQueryParameterName("redirectUrl");
    const [formData, setFormData] = useState(inputfield);
    const [screenState, setScreenState] = useState(forgotLoginIdState.FORGOT_LOGIN_ID);
    const [loginButtonDisable, setLoginDisable] = React.useState(false);
    let navigate = useNavigate();
    const handleChange = (event) => {
        event.target.name === "pan"
            ? setFormData(Object.assign(Object.assign({}, formData), { [event.target.name]: event.target.value.toUpperCase() }))
            : setFormData(Object.assign(Object.assign({}, formData), { [event.target.name]: event.target.value }));
        if (loginButtonDisable)
            setLoginDisable(false);
        for (let [key, val] of Object.entries(error)) {
            if (val === "")
                continue;
            setError(Object.assign(Object.assign({}, error), { [key]: inputfield[key] }));
        }
    };
    const [error, setError] = useState(inputfield);
    const [accountType, setAccountType] = useState(null);
    const [apiCall, setAPICall] = useState(false);
    const validationError = (field, value) => {
        setError(Object.assign(Object.assign({}, error), { [field]: value }));
    };
    const { data: ClientForgotUserID, loader: ClientForgotUserIDLoader, errorData: ClientForgotUserIDError, } = useSelector((state) => state.LoginFlow.ClientForgotUserID);
    const SubmitForgotLoginID = () => {
        let payload = {
            email: formData.email,
            pan: formData.pan,
            mobile: formData.mobile,
            mode: LoginRequestMode.BOTH,
            accTyp: accountType,
        };
        di.login.clientForgotUserID(payload);
        setAPICall(true);
    };
    const disableSubmit = () => {
        return (!(formData.email && formData.mobile && formData.pan) ||
            !(formData.mobile.length == 10 &&
                formData.pan.length == 10 &&
                formData.email.includes("@") &&
                formData.email.includes(".")) ||
            !(!error.mobile && !error.email && !error.pan) ||
            !accountType ||
            loginButtonDisable);
    };
    const handleErrorMessage = () => {
        let message = ClientForgotUserIDError.error.getErrorMessageOrErrMsg();
        switch (message) {
            case "mobile number is invalid":
                return (React.createElement(ErrorExclamation, { errorMessage: loginHelp.mobOrEmailInvalid, avoidExclamation: true, parentClass: "login-errorMsg-section" }));
            default:
                return React.createElement(ErrorExclamation, { errorMessage: message, avoidExclamation: true });
        }
    };
    const handleScreens = () => {
        switch (screenState) {
            case forgotLoginIdState.FORGOT_LOGIN_ID:
                return (React.createElement("div", { className: "unbloackaccount register-page-block p-3 bg-white" },
                    React.createElement("form", { id: "forgotLoginid-form", onSubmit: (e) => {
                            e.preventDefault();
                        } },
                        React.createElement(Row, null,
                            (device === null || device === void 0 ? void 0 : device.isDesktop) ? ("") : (React.createElement(React.Fragment, null,
                                React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "DMSansBold_20_700 txt-midnight-blue  col-lg-12 col-sm-12 col-12", style: { marginTop: "10px" } }, "Forgot Login ID"))),
                            React.createElement(ChooseAccountForLogin, { setAccountType: setAccountType, noGridContainer: true }),
                            React.createElement(Col, { className: "register-inputfield input-group register-inputfiled-mob mt-5 m-0" },
                                React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), pattern: phoneNo, onBlur: (error, event) => {
                                        if (!error.pattern)
                                            validationError(event.target.name, "Please enter a valid Phone Number");
                                        else if (error.required)
                                            validationError(event.target.name, "This field is Required");
                                        else
                                            validationError(event.target.name, "");
                                    }, errorText: error.mobile, highlightInputField: true, defaultValue: formData.mobile, placeholder: "Enter your mobile number", id: "mobile", name: "mobile", type: "number", maxLength: 10, min: 10, max: 10, autoComplete: "off", showLabel: true, prefix: number(), placeholderClassName: "floating-label ", className: "custom-form-control", required: true })),
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5" },
                                React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), defaultValue: formData.email, pattern: emailRegex, onBlur: (error, event) => {
                                        if (!error.pattern)
                                            validationError(event.target.name, "Please enter valid Email ID");
                                        else if (error.required)
                                            validationError(event.target.name, "This field is Required");
                                        else
                                            validationError(event.target.name, "");
                                    }, errorText: error.email, highlightInputField: true, placeholder: "Enter your email address", id: "email", name: "email", 
                                    // type="email"
                                    required: true, 
                                    // maxLength={50}
                                    autoComplete: "off", showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control" })),
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5" },
                                React.createElement(InputField, { onChangeEvent: (e) => handleChange(e), defaultValue: formData.pan, pattern: pan, onBlur: (error, event) => {
                                        if (!error.pattern)
                                            validationError(event.target.name, "Please enter valid PAN Number");
                                        else if (error.required)
                                            validationError(event.target.name, "This field is Required");
                                        else
                                            validationError(event.target.name, "");
                                    }, errorText: error.pan, highlightInputField: true, placeholder: "Enter your PAN", id: "pan", name: "pan", required: true, autoComplete: "off", showLabel: true, placeholderClassName: "floating-label ", className: "custom-form-control" }))),
                        !ClientForgotUserIDLoader &&
                            ClientForgotUserIDError.isOpen &&
                            loginButtonDisable &&
                            handleErrorMessage(),
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 12, sm: 12, xs: 12, className: "mt-5 mb-4" },
                                React.createElement(EdButton, { value: "Next", className: "w-100", disabled: disableSubmit(), btnTyp: "midnight-blue", onClick: SubmitForgotLoginID, type: "submit" }))))));
            case forgotLoginIdState.SUCCESS_STATE:
                return (React.createElement(PasswordResetMsg, { title: "Login Id Sent!", message: React.createElement(React.Fragment, null,
                        React.createElement("span", null,
                            "\"Your login ID has successfully been sent to your registered",
                            React.createElement("strong", null, " email ID"),
                            " and ",
                            React.createElement("strong", null, "mobile number."))), helpFlowPopup: props.helpFlowPopup, redirectUrlFromQueryParams: redirectUrlFromQueryParams }));
        }
    };
    useEffect(() => {
        if (screenState) {
            handleScreens();
        }
    }, [screenState]);
    useEffect(() => {
        if (!ClientForgotUserIDLoader && !ClientForgotUserIDError.isOpen) {
            if (ClientForgotUserID.success && apiCall)
                setScreenState(forgotLoginIdState.SUCCESS_STATE);
        }
        else if (!ClientForgotUserIDLoader && ClientForgotUserIDError.isOpen) {
            setLoginDisable(true);
        }
    }, [
        ClientForgotUserID,
        ClientForgotUserIDLoader,
        ClientForgotUserIDError,
        apiCall,
    ]);
    return React.createElement(React.Fragment, null, handleScreens());
};
export default ForgotLoginId;
